import UserItem from '../Contents/User/UserAdmin/UserItem.js';
import AuthService from './authService.js';
import SearchParams from '../Elements/SearchParams';
import UserSearchParams from '../Contents/User/UserAdmin/UserSearchParams';

class UserService {
  static GetOfficeIdOfLoggedInUser() {
    const user = AuthService.getInstance().GetLoggedInUser();
    return user ? user.officeId.toString() : '';
  }

  static GetUserList(clearCache = false) {
    const authService = AuthService.getInstance();
    const url = `/api/User?clearCache=${clearCache}`;
    return authService.CallBackendFunction(url);
  }

  static GetUserListForTimesheet() {
    const authService = AuthService.getInstance();
    const user = authService.GetLoggedInUser();
    const url = `/api/User/GetUsersForTimesheet/${user.userId}/?clearCache=false`;
    return authService.CallBackendFunction(url);
  }

  static async GetUserListForCommission(allowSelf) {
    const authService = AuthService.getInstance();

    const url = `/api/User/GetUserListForCommission?allowSelf=${allowSelf}`;

    return authService.CallBackendFunction(url);
  }

  static SaveUser(user) {
    const authService = AuthService.getInstance();
    const url = `/api/User/${user.userId}`;
    return authService.CallBackendFunctionPut(url, user);
  }
  static UpdateSubstitutedBy(userId, substitutionId) {
    const userJSON = JSON.stringify({
      UserId: userId.toString(),
      SubstitutedById: substitutionId.toString(),
    });
    const url = `api/User/UpdateSubstitutedBy/${userId}`;
    const authService = AuthService.getInstance();
    return authService.CallBackendFunctionPut(url, userJSON);
  }
  static UpdateTimeZone(userId, substitutionId) {
    const userJSON = JSON.stringify({
      UserId: userId.toString(),
      TimeZoneOffset: substitutionId.toString(),
    });
    const url = `api/User/UpdateTimeZone/${userId}`;
    const authService = AuthService.getInstance();
    return authService.CallBackendFunctionPut(url, userJSON);
  }
  static SaveEditedUser(user) {
    const userJSON = JSON.stringify({
      UserId: user.UserId.toString(),
      FirstName: user.FirstName,
      LastName: user.LastName,
      Email: user.Email,
      OfficeId: user.OfficeId.toString(),
      IsActive: user.IsActive.toString(),
      ApolloMgrId: user.ApolloMgrId ? user.ApolloMgrId.toString() : '',
      SupervisorId: user.SupervisorId ? user.SupervisorId.toString() : '',
      DepartmentId: user.DepartmentId ? user.DepartmentId.toString() : '',
      OfficialJobTitleId: user.OfficialJobTitleId ? user.OfficialJobTitleId.toString() : '',
      UserName: user.UserName,
      NotificationsEnabled: user.NotificationsEnabled.toString(),
      PosnumberId: user.PosnumberId.toString(),
      NoTs: user.NoTs,
      IsOutsourcedEmployee: user.IsOutsourcedEmployee.toString(),
      WorkforceType: user.WorkforceType,
      TimeZoneOffset: user.TimeZoneOffset,
      GroupIds: user.GroupIds,
      IncludeSecondaryAccountsInCostCalculation: user.IncludeSecondaryAccountsInCostCalculation,
      IncludeVendorCostInCostCalculation: user.IncludeVendorCostInCostCalculation,
    });
    const url = `api/User/SaveEditedUser/${user.UserId}`;
    const authService = AuthService.getInstance();
    return authService.CallBackendFunctionPut(url, userJSON);
  }

  static SaveRelatedUser(user) {
    const userJSON = JSON.stringify({
      UserId: user.UserId.toString(),
      UserName: user.UserName,
      OfficeId: user.OfficeId.toString(),
      Roles: user.SelectedCaspianRoles,
    });
    const url = `api/User/SaveRelatedUser/${user.UserId}`;
    const authService = AuthService.getInstance();
    return authService.CallBackendFunctionPut(url, userJSON);
  }

  static ChangeOffice(userData) {
    const userDataJSON = JSON.stringify({ UserId: userData.userId, OfficeId: userData.officeId });
    const url = 'api/User/ChangeOffice/';
    const authService = AuthService.getInstance();
    return authService.CallBackendFunctionPost(url, userDataJSON);
  }

  static CreateRelatedUser(user) {
    const userJSON = JSON.stringify({
      UserId: user.UserId.toString(),
      UserName: user.UserName,
      OfficeId: user.OfficeId.toString(),
      Roles: user.SelectedCaspianRoles,
    });
    const url = `api/User/CreateRelatedUser/${user.UserId}`;
    const authService = AuthService.getInstance();
    return authService.CallBackendFunctionPut(url, userJSON);
  }

  static MassSupervisorChange(supervisorChangeItem) {
    const supervisorChangeItemJSON = JSON.stringify(UserService.ConvertAllPropertyToString(supervisorChangeItem));
    const url = 'api/User/MassSupervisorChange/';
    const authService = AuthService.getInstance();
    return authService.CallBackendFunctionPut(url, supervisorChangeItemJSON);
  }

  static ConvertAllPropertyToString(item) {
    for (const key in item) {
      if (Object.hasOwnProperty.call(item, key)) {
        item[key] = item[key].toString();
      }
    }
    return item;
  }

  static CreateUser(user) {
    const userJSON = JSON.stringify({
      FirstName: user.FirstName,
      LastName: user.LastName,
      Email: user.Email,
      IsActive: user.IsActive.toString(),
      ApolloMgrId: user.ApolloMgrId.toString(),
      SupervisorId: user.SupervisorId.toString(),
      DepartmentId: user.DepartmentId.toString(),
      OfficialJobTitleId: user.OfficialJobTitleId.toString(),
      OfficeId: user.OfficeId.toString(),
      UserName: user.UserName,
      NotificationsEnabled: user.NotificationsEnabled.toString(),
      PosnumberId: user.PosnumberId.toString(),
      NoTs: user.NoTs,
      IsOutsourcedEmployee: user.IsOutsourcedEmployee.toString(),
      WorkforceType: user.WorkforceType,
      IncludeSecondaryAccountsInCostCalculation: user.IncludeSecondaryAccountsInCostCalculation,
    });
    const url = 'api/User/CreateUser/';
    const authService = AuthService.getInstance();
    return authService.CallBackendFunctionPost(url, userJSON);
  }

  static GetUserListBySearching(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache) {
    const searchParams = new SearchParams(
      searchItem,
      UserSearchParams,
      orderById,
      orderDir,
      pageNumber,
      numberOfElements
    );

    const url = `/api/User/GetUsers/?searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`;
    return AuthService.getInstance().CallBackendFunction(url);
  }

  static GetUserById(id) {
    // console.log('UserService.GetUserById - Fetching user by id: ', id);
    return AuthService.getInstance()
      .CallBackendFunction(`/api/User/GetUserById/${id}?clearCache=false`)
      .then((user) => {
        // console.log('UserService.GetUserById - Fetched user: ', user);
        return user;
      })
      .catch((error) => {
        // console.error('UserService.GetUserById - Error fetching user: ', error);
        throw error;
      });
  }

  static GetUserByGuidId(guidId) {
    // console.log('UserService.GetUserByGuidId - Fetching user by GUID id: ', guidId);
    return AuthService.getInstance()
      .CallBackendFunction(`/api/User/GetUserByGuidId/${guidId}?clearCache=false`)
      .then((user) => {
        // console.log('UserService.GetUserByGuidId - Fetched user: ', user);
        return user;
      })
      .catch((error) => {
        // console.error('UserService.GetUserById - Error fetching user: ', error);
        throw error;
      });
  }

  static ConvertDBUser(Items) {
    const convertedItems = [];

    if (Items !== null) {
      Items.forEach((item) => {
        const newItem = new UserItem(item);
        convertedItems.push(newItem);
      });
    }

    return convertedItems;
  }

  static async SaveTimesheetUser(item) {
    const timesheetUserId = item.RelatedUsers.find((user) => user.userName === item.TimesheetUserUserName).userId;

    const timesheetUserIdJSON = JSON.stringify({
      UserId: item.UserId,
      TimesheetUserId: timesheetUserId,
    });

    const url = `api/User/SaveTimesheetUser/${item.UserId}`;
    const authService = AuthService.getInstance();
    return authService.CallBackendFunctionPut(url, timesheetUserIdJSON);
  }

  static async GetOfficesOfTheUser() {
    const url = 'api/User/GetOfficeIdsOfLoggedInUser/';
    const authService = AuthService.getInstance();
    return authService.CallBackendFunction(url);
  }

  static GrantTimesheetExtendedEditPermission(user) {
    const userItemJSON = JSON.stringify(user);
    const url = 'api/User/GrantTimesheetExtendedEditPermission/';
    const authService = AuthService.getInstance();
    return authService.CallBackendFunctionPut(url, userItemJSON);
  }

  static getUsersBySupervisorId(id) {
    return AuthService.getInstance().CallBackendFunction(`/api/User/GetUsersBySupervisorId/${id}?clearCache=false`);
  }
}

export default UserService;
